export const actionCopy = {
  labels: {
    addTag: 'Add tag',
    accountSettings: 'Account Settings',
    cancelInvitation: 'Cancel Invitation',
    columns: 'Columns',
    copy: 'Copy',
    delete: 'Delete',
    edit: 'Edit',
    editTags: 'Edit tags',
    open: 'Open',
    refresh: 'Refresh',
    reset: 'Reset',
    restore: 'Restore',
    retry: 'Retry',
    revoke: 'Revoke',
    sort: 'Sort',
    test: 'Test',
    update: 'Update',
    upload: 'Upload',
    viewDetails: 'View details',
  },
} as const;

export type ActionLabelKey = keyof typeof actionCopy.labels;
export type EntityActionVerb = 'delete' | 'edit' | 'restore';
export type TargetActionVerb = 'copy' | 'delete' | 'edit' | 'revoke' | 'test' | 'upload';

export const getActionLabel = (key: ActionLabelKey): string => actionCopy.labels[key];

export const getEntityActionLabel = (verb: EntityActionVerb, entityLabel: string): string =>
  `${getActionLabel(verb)} ${entityLabel}`;

export const getTargetActionLabel = (verb: TargetActionVerb, targetLabel: string): string =>
  `${getActionLabel(verb)} ${targetLabel}`;

export const getProjectSettingsActionLabel = (): string => 'Go to Project Settings';

export const getActionAriaLabel = (
  action: 'copy' | 'delete' | 'edit' | 'open' | 'rowActions',
  target: string,
): string => {
  if (action === 'rowActions') return `Row actions for ${target}`;
  return `${getActionLabel(action)} ${target}`;
};

export const getQuickSortActionCopy = (
  label: string,
  nextDirectionLabel: 'ascending' | 'descending' | 'reset',
): { ariaLabel: string; tooltip: string } => ({
  ariaLabel: `Quick sort ${label}`,
  tooltip:
    nextDirectionLabel === 'reset'
      ? `Reset ${label} sort`
      : `Sort by ${label} ${nextDirectionLabel}`,
});

export const getActionCopySamples = (): string[] => [
  ...Object.values(actionCopy.labels),
  getEntityActionLabel('edit', 'Test'),
  getEntityActionLabel('delete', 'Test'),
  getEntityActionLabel('restore', 'Upload'),
  getTargetActionLabel('copy', 'project ID'),
  getProjectSettingsActionLabel(),
  getActionAriaLabel('rowActions', 'Example row'),
  getQuickSortActionCopy('Pass rate', 'ascending').ariaLabel,
  getQuickSortActionCopy('Pass rate', 'ascending').tooltip,
];
